import dayjs from "dayjs";
import { useMemo } from "react";
import { AdminCalendarIcon, AdminTimeIcon2 } from "../../AscIcons";
import AscTable from "../AscTable";
import styles from "./AscAdminsList.module.scss";

enum DataAdminListEnum {
  userName = "userName",
  role = "role",
  actions = "actions",
  date = "date",
  time = "time",
}

type DataAdminList = {
  userName: string;
  role: string;
  actions: string;
  date: string | any;
  time: string;
};

interface IAdminListProps {
  data: DataAdminList[] | any;
}

export default function AscAdminsList(props: IAdminListProps) {
  const { data } = props;
  const tableData: DataAdminList[] = useMemo(() => [...data], [data]);

  const tableColumns = useMemo(() => {
    const columns = [
      {
        Header: () => {
          return <p className={styles.headName}>User </p>;
        },
        accessor: DataAdminListEnum.userName,
        Cell: (cell: { value: any }) => {
          return <div className={styles.userName}>{cell.value}</div>;
        },
      },

      {
        Header: () => {
          return <p className={styles.headName}>Role </p>;
        },
        accessor: DataAdminListEnum.role,
        Cell: (cell: { value: any }) => {
          return (
            <div className={styles.roleGround}>
              <div className={styles.circle} />
              {cell.value}
            </div>
          );
        },
      },

      {
        Header: () => {
          return <p className={styles.headName}>Actions </p>;
        },
        accessor: DataAdminListEnum.actions,
      },

      {
        Header: () => {
          return <p className={styles.headName}>Date </p>;
        },
        accessor: DataAdminListEnum.date,
        Cell: (cell: { value: any }) => {
          return (
            <div className={styles.dateGround}>
              <AdminCalendarIcon className={styles.iconCalendar} />
              {dayjs(cell.value).format("DD MMMM YYYY")}
            </div>
          );
        },
      },

      {
        Header: () => {
          return <p className={styles.headName}>Time </p>;
        },
        accessor: DataAdminListEnum.time,
        Cell: (cell: { value: any }) => {
          return (
            <div className={styles.timeGround}>
              <AdminTimeIcon2 className={styles.iconTime} />
              {dayjs(cell.value).format("HH:mm A")}
            </div>
          );
        },
      },
    ];

    return columns;
  }, [tableData]);
  return (
    <AscTable
      tHead={styles.tHead}
      tBody={styles.tBody}
      tHeadRow={styles.tHeadRow}
      pureCellFlow={styles.pureCellFlow}
      tH={styles.tH}
      tD={styles.tD}
      tBodyValue={styles.tBodyValue}
      className={styles.table}
      tableColumns={tableColumns}
      tableData={tableData}
      showHeader={true}
    />
  );
}
